import type { Accessor } from "solid-js";
import { isFunction, isNil } from "lodash-es";

// Allows for narrowing down TypeScript types (useful for Show/Match components)
export const narrow = <A, B extends A>(
  value: Accessor<A> | A,
  guard: (v: NonNullable<A>) => v is NonNullable<B>,
): B | null => {
  const resolvedValue = isFunction(value) ? value() : value;
  return !isNil(resolvedValue) && guard(resolvedValue as NonNullable<A>) ? (resolvedValue as B) : null;
};

// Allows for easier condition checking and passing on the value as args in the children
export const condition = <A>(v: A, condition: (v: A) => boolean): A | null => (condition(v) ? v : null);
